import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const navLinks = ['Home', 'Courses', 'Books', 'Apps'];
  const policyLinks = [
    { label: 'Privacy Policy', path: null },
    { label: 'Terms & Conditions', path: null },
    { label: 'Refund Policy', path: '/refund-policy' },
  ];
  const extraLinks = ['Cookie Policy', 'Disclaimer'];

  const handleNavClick = (link) => {
    const sectionMap = { Home: 'hero', Courses: 'courses', Books: 'books', Apps: 'apps' };
    const id = sectionMap[link];
    if (id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer style={{
      background: '#0a0716',
      padding: '50px 20px 30px',
      borderTop: '1px solid rgba(139, 92, 246, 0.15)',
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
        {/* License Badge */}
        <div style={{
          display: 'inline-block',
          border: '1px solid rgba(139, 92, 246, 0.3)',
          borderRadius: '24px',
          padding: '10px 28px',
          marginBottom: '30px',
          background: 'rgba(88, 28, 135, 0.1)',
        }}>
          <span style={{ fontSize: '14px', color: '#b0adc0' }}>
            Licensed in Dubai, U.A.E. | License #2646553.01
          </span>
        </div>

        {/* Nav Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '28px',
          marginBottom: '16px',
          flexWrap: 'wrap',
        }}>
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => handleNavClick(link)}
              style={{
                background: 'none',
                border: 'none',
                color: '#b0adc0',
                fontSize: '14px',
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
              onMouseEnter={(e) => { e.target.style.color = '#ffffff'; }}
              onMouseLeave={(e) => { e.target.style.color = '#b0adc0'; }}
            >
              {link}
            </button>
          ))}
        </div>

        {/* Policy Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '28px',
          marginBottom: '16px',
          flexWrap: 'wrap',
        }}>
          {policyLinks.map((item) => (
            <button
              key={item.label}
              onClick={() => { if (item.path) navigate(item.path); }}
              style={{
                background: 'none',
                border: 'none',
                color: '#8885a0',
                fontSize: '13px',
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
              onMouseEnter={(e) => { e.target.style.color = '#b0adc0'; }}
              onMouseLeave={(e) => { e.target.style.color = '#8885a0'; }}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Extra Links */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '28px',
          marginBottom: '32px',
          flexWrap: 'wrap',
        }}>
          {extraLinks.map((link) => (
            <button
              key={link}
              style={{
                background: 'none',
                border: 'none',
                color: '#8885a0',
                fontSize: '13px',
                cursor: 'pointer',
                fontFamily: 'Inter, sans-serif',
              }}
              onMouseEnter={(e) => { e.target.style.color = '#b0adc0'; }}
              onMouseLeave={(e) => { e.target.style.color = '#8885a0'; }}
            >
              {link}
            </button>
          ))}
        </div>

        {/* Divider */}
        <div style={{
          width: '100%',
          height: '1px',
          background: 'rgba(139, 92, 246, 0.1)',
          marginBottom: '24px',
        }} />

        {/* Copyright */}
        <p style={{ fontSize: '13px', color: '#8885a0', marginBottom: '6px' }}>
          © 2026 The Inner Bridge (Innovation Lifestyle Consultancy L.L.C-FZ). All rights reserved.
        </p>
        <p style={{ fontSize: '13px', color: '#8885a0' }}>
          Empowering consciousness. Illuminating paths. Bridging dimensions.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
